module.exports = __webpack_public_path__ + "img/70f56fb.png";